var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v(_vm._s(_vm.title))])])],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }